import { FC } from 'react'

import { Input, InputProps } from 'antd'
import styled from 'styled-components'

import SearchIcon from 'src/Assets/Svg/pages-icons/Search.svg?react'
import CloseIcon from 'src/Assets/Svg/pages-icons/Close.svg?react'

const StyledInput = styled(Input)`
  border-radius: 40px;
  border: 1px solid transparent;
  padding: 12px 16px;
  background-color: ${({ theme }) => theme.color.white};
  width: 180px;
  color: ${({ theme }) => theme.color.darkGrey};
  font-family: 'Segoe UI';
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  @media screen and (max-width: 767px) {
    border-radius: 50%;
    width: 48px;
    input::placeholder {
      visibility: hidden;
    }
    .ant-input-clear-icon {
      visibility: hidden;
    }
  }

  input::placeholder {
    overflow: hidden;
    color: ${({ theme }) => theme.color.darkGrey};
    text-overflow: ellipsis;
    font-family: 'Segoe UI';
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
  }
  &:hover:enabled {
    border: 1px solid ${({ theme }) => theme.color.lightGrey} !important;
    background-color: ${({ theme }) => theme.color.hoverWhite};
    cursor: text;
  }
  &:focus-visible,
  &:focus,
  &:focus-within {
    border-radius: 40px;
    border-color: ${({ theme }) => theme.color.mediumGrey};
    background-color: ${({ theme }) => theme.color.white};

    box-shadow: none;
    width: 320px;
    @media screen and (max-width: 767px) {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      input::placeholder {
        visibility: visible;
      }
      .ant-input-clear-icon {
        visibility: visible;
      }
    }
  }

  .ant-input-clear-icon,
  .ant-input-prefix {
    display: flex;
    align-items: center;
    justify-content: center;
    svg {
      fill: ${({ theme }) => theme.color.darkGrey};
    }
  }
  &.ant-input-disabled {
    background-color: ${({ theme }) => theme.color.white};
    box-shadow: none;
    border: 1px solid transparent;
    input::placeholder {
      color: ${({ theme }) => theme.color.lightGrey};
    }
    .ant-input-prefix svg {
      fill: ${({ theme }) => theme.color.lightGrey};
    }
  }
  &.ant-input-outlined:hover:not([disabled]) {
    border: 1px solid ${({ theme }) => theme.color.mediumGrey} !important;
    outline: none;
    background-color: ${({ theme }) => theme.color.hoverWhite} !important;
  }
  &.ant-input-disabled:hover:not([disabled]) {
    border: 1px solid ${({ theme }) => theme.color.mediumGrey} !important;
    outline: none;
    background-color: ${({ theme }) => theme.color.hoverWhite} !important;
  }
`

export type CollapsedSearchInputProps = InputProps

export const CollapsedSearchInput: FC<CollapsedSearchInputProps> = (props) => (
  <StyledInput
    allowClear={{ clearIcon: <CloseIcon /> }}
    prefix={<SearchIcon />}
    {...props}
  ></StyledInput>
)
